<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
      
        <!--  <b-breadcrumb :items="breadcrumbs"/>   -->
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> COD HUB Collection Closure </strong>
          </div>
          <b-row class="">

           

            <b-col md="12" class="my-1">
              <form name="fileform" @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
                <b-row>
                  <b-col cols="4">
                    <b-form-group label="HUB Name ">
                        <b-input-group >                     
                            <b-form-input class="input" type="text" name="HUB Name" v-model="hub_name" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.HUB Name') }" disabled>
                            </b-form-input>
                            <span style="text-align:left;" v-show="errors.has('form-1.HUB Name')" class="help text-danger">{{ errors.first('form-1.HUB Name') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                   <b-col cols="4">
                    <b-form-group label="COD Deposit Date">
                        <b-input-group >                     
                            <b-form-input class="input" type="text" name="COD Collection Date" v-model="codCollectionDate" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.COD Collection Date') }" disabled>
                            </b-form-input>
                            <span style="text-align:left;" v-show="errors.has('form-1.COD Collection Date')" class="help text-danger">{{ errors.first('form-1.COD Collection Date') }}</span>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                   <b-col cols="4">
                    <b-form-group label="Upload Receipt">
                            <b-form-file
                            v-model="file"
                            :state="Boolean(file)"
                            placeholder="Upload Design File"
                            @change="selectFile($event)"
                            :class="{
                                input: true,
                                'text-danger': errors.has('form-1.file'),
                            }"
                            ></b-form-file>
                    </b-form-group>
                  </b-col> 

                </b-row>

                <b-row class="mt-3">
                   <b-col cols="3">
                    <b-form-group label="Receipt No">
                        <b-input-group >                     
                            <b-form-input class="input" type="text" name="Receipt No" v-model="receiptno" v-validate="'required'" :class="{'input': true, 'text-danger': errors.has('form-1.Receipt No') }">
                            </b-form-input>
                            
                      </b-input-group>
                        <!-- <span style="text-align:left;" v-show="errors.has('form-1.Receipt No')" class="help text-danger mt-1">{{ errors.first('form-1.Receipt No') }}</span> -->
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group label="Total COD Amount In HUB">
                        <b-input-group >                     
                            <b-form-input class="input" type="text" name="Total Cod Amount In Hub" v-model="totalCodAmountInHub" v-validate="'required|numeric'" :class="{'input': true, 'text-danger': errors.has('form-1.Total Cod Amount In Hub') }" disabled>
                            </b-form-input>
                            
                      </b-input-group>
                        <span style="text-align:left;" v-show="errors.has('form-1.Total Cod Amount In Hub')" class="help text-danger mt-1">{{ errors.first('form-1.Total Cod Amount In Hub') }}</span>
                    </b-form-group>
                  </b-col>

                   <b-col cols="3">
                    <b-form-group label="COD Deposit">
                        <b-input-group >                     
                            <b-form-input class="input" type="number" step="any" name="COD Submiited" v-model="codSubmiited" :class="{'input': true, 'text-danger': errors.has('form-1.COD Submiited') }" @input="calculateDeficientAmt" required>
                            </b-form-input> 
                           <!-- <input type="number" step="any" class="form-control" name="COD Submiited" v-model="codSubmiited" @input="calculateDeficientAmt" required> -->
                      </b-input-group>
                    <!-- <span style="text-align:left;" v-show="errors.has('form-1.COD Submiited')" class="help text-danger mt-1">{{ errors.first('form-1.COD Submiited') }}</span> -->
                    </b-form-group>
                  </b-col>

                   <b-col cols="3">
                    <b-form-group label="Deficit Amount">
                        <b-input-group >                     
                            <b-form-input class="input" type="text" name="Deficient Amount" v-model="deficientamount" v-validate="'required|numeric'" :class="{'input': true, 'text-danger': errors.has('form-1.Deficient Amount') }" disabled>
                            </b-form-input>
                            
                      </b-input-group>
                        <span style="text-align:left;" v-show="errors.has('form-1.Deficient Amount')" class="help text-danger mt-1">{{ errors.first('form-1.Deficient Amount') }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col cols="6">
                    <b-form-group label="Remark">
                        <b-input-group >                     
                            <b-form-input class="input" type="text" name="Remark" v-model="remark"  :class="{'input': true, 'text-danger': errors.has('form-1.Remark') }" >
                            </b-form-input>                          
                      </b-input-group>
                        <span style="text-align:left;" v-show="errors.has('form-1.Remark')" class="help text-danger mt-1">{{ errors.first('form-1.Remark') }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row  >
                  <div v-for="(image , index) in uploadImages" :key="index" class="d-flex align-items-center ml-3 mt-2">
                    <b-button  variant="secondary" >
                      <a :href="image.fileUrl" :download="image.fileName">{{ image.fileName }}</a>
                    </b-button>
                    <span class="btn ml-2" style="font-size: x-large;" @click="removeDoc(index)">&times;</span>
                
                  </div>         
                </b-row>

                <b-row>
                  <b-col cols="4 mt-3">
                    <b-button size="md" variant="primary" type="submit" >Submit</b-button>
                  </b-col>
                </b-row>
              </form>
                <hr>
              <b-row class="mt-5">
                 <b-col cols="4">
                    <b-form-group label="From Date : "  :label-cols="3" >
                      <v-date-picker
                        mode="single"
                        input-class="dateInput"
                        :available-dates="{ start: null, end: new Date() }"
                        v-model="fromDate"
                      >
                      </v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col cols="4">
                    <b-form-group label="To Date : "  :label-cols="3" >
                      <v-date-picker
                        mode="single"
                        input-class="dateInput"
                        :available-dates="{ start: null, end: new Date() }"
                        v-model="toDate"
                      >
                      </v-date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2" style="text-align:left;">
                    <b-form-group>
                      <button class="btn btn-primary" @click="searchClosureList()"> Search
                        </button>
                        <button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i>
                        </button>
                    </b-form-group>
                  </b-col>
                  <b-col cols="2" style="text-align:right;" v-if="isDownloadBtn == true ">
                    <b-form-group>
                      <button class="btn btn-primary" @click="getCodCollectionClosureCSV">Download
                        </button> 
                    </b-form-group>
                  </b-col>
             </b-row>

                <b-row>
                    <b-table
                      responsive
                      class="tableOFD"
                      show-empty
                      stacked="md"
                      :items="codData"
                      :fields="fields"
                      :bordered="bordered"
                      thead-class="Collected"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      @filtered="onFiltered"
                      :busy="isBusy"

                    >
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                      
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>

                      <template slot="Srno" slot-scope="row">
                          <p>{{ ((pageNo-1) * perPage) + row.index + 1}}</p>
                      </template>

                      <template slot="codcollectiondate" slot-scope="row">
                          <p >{{formatDate(row.item.cod_collection_date)}}</p>
                    
                      </template> 

                      <template slot="finance_query" slot-scope="row">
                        <p v-if="row.item.status == 'Rejected'" >{{ row.item.finance_query }}</p>
                      </template> 

                       <!-- <template slot="docupload" slot-scope="row">
                         <p v-if="row.item.uploaded_doc.length > 0 " style="text-align: center; color:green">
                          <a  v-for="item in row.item.uploaded_doc" :href="item.fileUrl" download >
                           <i class="fa fa-download" v-b-tooltip.hover :title="item.fileName"></i>
                         </a>

                        </p>
                      </template> -->
                      <template slot="docupload" slot-scope="row">
                        <b-button v-if="row.item.uploaded_doc.length > 0" size="sm" @click="openDocModal(row.item)">Show Docs</b-button>
                      </template>
                       
                      <template slot="finalstatus" slot-scope="row">
                        <button class="btn btn-primary">
                          {{row.item.status}}
                        </button>
                        <b-button
                          v-if="row.item.status==='Rejected'"
                          @click="row.toggleDetails();editCollectionClosure(row,row.detailsShowing);"
                          class="btn btn-primary ml-2"
                          style="background: #b0c4de !important;color: #000 !important;"
                        >
                          {{ row.detailsShowing ? "Hide" : "Edit" }} COD
                        </b-button>
                      </template>

                      <template slot="row-details" slot-scope="row">
                        <b-card title="Edit COD">
                          <form @submit.prevent="updateCodCollection(row)">
                            <b-row>
                              <b-col cols="3">
                                <b-form-group label="Total COD Amount In HUB">
                                  <b-input-group >                     
                                    <b-form-input class="input" type="text" name="Total Cod Amount In Hub" v-model="editTotalCodAmountInHub" v-validate="'required|numeric'" disabled>
                                    </b-form-input>                                        
                                  </b-input-group>                                    
                                </b-form-group>
                              </b-col>

                              <b-col cols="3">
                                <b-form-group label="COD Deposit">
                                  <b-input-group >                     
                                    <b-form-input class="input" type="number" step="any" name="COD Submiited" v-model="editCodSubmiited" v-validate="'required|numeric'"  @input="calculateEditDeficientAmt">
                                    </b-form-input>                                    
                                  </b-input-group>                               
                                </b-form-group>
                              </b-col>

                              <b-col cols="3">
                                <b-form-group label="Deficit Amount">
                                  <b-input-group >                     
                                    <b-form-input class="input" type="text" name="Deficient Amount" v-model="editDeficientamount" v-validate="'required|numeric'"  disabled>
                                    </b-form-input>                                        
                                  </b-input-group>                                   
                                </b-form-group>
                              </b-col>

                              <b-col cols="3">
                                <b-form-group label="Receipt No">
                                  <b-input-group >                     
                                    <b-form-input class="input" type="text" name="Receipt No" v-model="editReceiptno" v-validate="'required'">
                                    </b-form-input>                                       
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                            </b-row>

                            <b-row>
                              <b-col cols="4">
                                <b-form-group label="Upload Receipt">
                                        <b-form-file
                                        v-model="editFile"
                                        :state="Boolean(editFile)"
                                        placeholder="Upload Design File"
                                        @change="selectFile($event)"                                        
                                        ></b-form-file>
                                </b-form-group>
                              </b-col>

                              <b-col cols="6">
                                <b-form-group label="Remark">
                                  <b-input-group >                     
                                    <b-form-input class="input" type="text" name="Remark" v-model="editRemark" >
                                    </b-form-input>                                       
                                  </b-input-group>
                                </b-form-group>
                              </b-col>
                            </b-row>

                            <b-row  >
                              <div v-for="(image , index) in editUploadedImages" :key="index" class="d-flex align-items-center ml-3 mt-2">
                                <b-button  variant="secondary" >
                                  <a :href="image.fileUrl" :download="image.fileName">{{ image.fileName }}</a>
                                </b-button>
                                <span class="btn ml-2" style="font-size: x-large;" @click="removeEditDoc(index)">&times;</span>
                            
                              </div>         
                            </b-row>

                            <b-row>
                              <b-col cols="4 mt-3">
                                <b-button size="md" variant="primary" type="submit">Update</b-button>
                              </b-col>
                            </b-row>
                            <b-col sm="12">
                              <div slot="footer" class="text-right">
                                <b-button
                                  size="sm"
                                  @click="row.toggleDetails"
                                  variant="danger"
                                  style="background: #b0c4de !important;color: #000 !important;"
                                  >Cancle</b-button
                                >
                              </div>
                            </b-col>
                          </form>
                        </b-card>
                      </template>

                      <!-- <template slot="finalstatus" slot-scope="row">
                        <div v-if="row.item.status=='Rejected'">
                          <button class="btn btn-primary">
                            {{row.item.status}}
                          </button>
                          <button class="btn btn-primary ml-2" @click="editCollectionClosure(row)">
                            Edit
                          </button>
                        </div>
                        <div v-else>
                          <button class="btn btn-primary">
                            {{row.item.status}}
                          </button>
                        </div>
                      </template> -->
                    </b-table>
                </b-row>
            </b-col>
            
          </b-row>

          <b-col md="12" class="my-1 ">
            <paginate         
                v-model="pageNo"
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :current-page="currentPage"
              >
              </paginate>
          </b-col>  
          <b-modal v-model="docModal" title="Uploaded Docs" size="lg" hide-footer>
            <table class="table table-striped">
              <tr>
                  <th >Document Name  </th>
                  <th > Download </th>
              </tr>
              <tr v-for="file in showDocs">
                  <td >{{ file.fileName }} </td>
                  <td style="text-align: center;"> 
                    <a  :href="file.fileUrl" download >
                      <i class="fa fa-download" v-b-tooltip.hover :title="file.fileName"></i>
                    </a>
                  </td>
              </tr>
            </table>

          </b-modal>
        </b-card>
      </b-col> 
       
      
      </b-row>

  </div>
</template>




<script>
import CONSTANTS from "@/utils/constants";
import Filters from "@/utils/filters";
import Utils from "@/utils";
export default {
  data: function() {
    return {
     isBusy: false,
     
     codCollectionDate: '',
     fields: [
        {
          key: "Srno",
          label: "Sr.No",
        },
        {
          key: "codcollectiondate",
          label: "Date Of COD Deposit",
        },
        {
          key: "cod_submitted",
          label: "COD Amount Deposit",
        },
        {
          key: "deficient_amount",
          label: "Deficit Amount",
        },
        {
          key: "total_cod_amount_in_hub",
          label: "Total COD In HUB",
        },
        {
          key: "receipt_no",
          label: "Receipt No",
        },
        {
          key: "remark",
          label: "Remark",
        },
        {
          key: "docupload",
          label: "Uploaded Doc",
        },
        {
          key: "finance_query",
          label: "Finance Query",
        },
        { key: "finalstatus", label: "Finance Status" },
      ],
      hub_name:'',
      totalCodAmountInHub:'',
      remark:'',
      deficientamount:0,
      codSubmiited:null,
      sampleImageurl:'',
      receiptno:'',
      file:'',
      codData:[],
       perPage: 10,
        currentPage: 1,
        pageNo: 1,
        noofpages: 0,
      toDate:new Date(),
      fromDate:new Date(),
     downloadcsv:'',
     isDownloadBtn: true,
     uploadImages : [],
     showDocs: [],
     docModal: false,

     //for edit cod
      editTotalCodAmountInHub:'',
      editDeficientamount: 0,
      editCodSubmiited:'',
      editReceiptno:'',
      editFile:'',
      isEditOn: false,
      editUploadedImages : [],
      editRemark:'',
    }
  },


   created: function() {

    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.hub_name = userInfo.pickuplocationname
    this.totalcodinhubwithdeficientamt();
    // this.getCodCollectionClosureList()
  
  },

   mounted() {
    this.getcodCollectionDate();
  },


   methods: {

     getcodCollectionDate() {
      const today = new Date();
      const year = today.getFullYear();
      let month = today.getMonth() + 1;
      let day = today.getDate();

      // Adding leading zero for single-digit month and day
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;

      this.codCollectionDate = `${year}-${month}-${day}`;
    },
  
    validateForm(scope) {
         
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;

        if(this.codSubmiited <= 0){
          this.$fire({
            text:"COD Deposit should be greater than 0",
            type: "warning",
            timer: 30000
          }); 
        }

        else if(this.uploadImages.length == 0){
          this.$fire({
            text:"Please Upload Document",
            type: "warning",
            timer: 30000
          }); 
        }

        else if(this.deficientamount < 0 ){
          this.$fire({
            text:"Deficit Amount cannot be less than 0",
            type: "warning",
            timer: 30000
          }); 
        }

        else{  
          document.getElementById("overlay").style.display = "block";
          var obj={
            hub_id:currenthub.toString(),
            hub_name: this.hub_name ,
            cod_collection_date: this.codCollectionDate,
            total_cod_amount_in_hub: this.totalCodAmountInHub ,
            cod_submitted: this.codSubmiited ,
            deficient_amount: this.deficientamount,
            receipt_no: this.receiptno,
           // uploaded_doc: this.sampleImageurl,
            uploaded_doc:JSON.stringify(this.uploadImages),
            remark: this.remark,
            created_by: userInfo.sysemailid
          }
          this.$http
            .post(`${CONSTANTS.MIGRATION_API_URL}/addCodCollectionClosure`, obj)
            .then(result => {
              document.getElementById("overlay").style.display = "none";
              if(result.body.returnmsg=='Successful'){

                  this.$fire({
                    text:"Data added successfully",
                    type: "success",
                    timer: 30000
                  }); 
                  //this.getCodCollectionClosureList(this.pageNo)
                  this.codSubmiited =null
                  this.receiptno =''
                  this.sampleImageurl= ''
                  this.file =''
                  this.deficientamount = 0
                  this.remark = ''
                  this.uploadImages = []
                  this.totalcodinhubwithdeficientamt();
              } else{

                  this.$fire({
                    text:result.body.returnvalue,
                    type: "error",
                    timer: 30000
                  }); 
              }
            })
            .catch(ex =>{
              console.log('error',ex)
            })
        }
    },

    selectFile(event){
     // console.log("Image----->",event.target.files[0].name);
 
    document.getElementById("overlay").style.display = "block";
      this.selectedFiles = event.target.files[0];
      var fileObj={}
       //fileObj.fileName=event.target.files[0].name;

      var editFileObj={}
       
         let data = new FormData();
          let config = {
              header : {
               'Content-Type' : 'multipart/form-data'
             }
            }
            data.append('file', this.selectedFiles)
         this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/uploadImageToS3`,data, {header : {
           'Content-Type' : 'multipart/form-data'
         },
         })
          .then(Response => {
            document.getElementById("overlay").style.display = "none";
             if(Response.data.result == 'success'){
              if(this.isEditOn){
                editFileObj.fileName = event.target.files[0].name;
                editFileObj['fileUrl']=Response.data.image_url
                this.editUploadedImages.push(editFileObj)
              }
              else{
                fileObj.fileName=event.target.files[0].name;
                fileObj['fileUrl']=Response.data.image_url
                this.uploadImages.push(fileObj)
              }
              
                this.sampleImageurl = Response.data.image_url;
                this.editFile = Response.data.image_url
                this.file=null;
                console.log(this.sampleImageurl)
            } else {
               
                this.sampleImageurl='';
            }
            })
    },

    removeDoc(index){
      this.uploadImages.splice(index,1)      
    },

    removeEditDoc(index){
      this.editUploadedImages.splice(index,1)
    },

    openDocModal(files){
      this.showDocs = [...files.uploaded_doc];
      this.docModal = true;   
    },


    totalcodinhubwithdeficientamt(){

        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;

        var hubobj={
          hub_id:currenthub.toString()
        }
         this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/getTotalCODAmountInHUB`,hubobj)
          .then(result => {
  
            if(result.body.returnmsg=='Successful'){
            
              this.totalCodAmountInHub = result.body.returnvalue[0].total_cod_amount_in_hub;
              console.log(this.totalCodAmountInHub)
              if(this.isEditOn){
                this.editTotalCodAmountInHub = result.body.returnvalue[0].total_cod_amount_in_hub;
                this.calculateEditDeficientAmt();
              }
              if(this.isEditOn===false){
                this.getCodCollectionClosureList(this.pageNo)
              }
            }
            else{
              this.codTotalAmtData =[]
            }
           
          })
          .catch(ex => {
            console.log('error', ex)
          });
    },


    clickCallback(pageNo)
   {
        console.log('pageNo--------->',pageNo)
        this.getCodCollectionClosureList(pageNo)
   },


      getCodCollectionClosureList(pageNo){
        console.log("Current--Page--->",this.currentPage)
        // alert(this.codCollectionDate)
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;

        var hubobj={
          hub_id:currenthub.toString(),
          fromdate: this.fromDate ? this.formatDate(this.fromDate) : this.codCollectionDate,
          todate: this.toDate ? this.formatDate(this.toDate) : this.codCollectionDate,
          page_no: pageNo ? pageNo : 1,
          limit: 10
        }
         this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/getCodCollectionClosureList`,hubobj)
          .then(result => {
  
            if(result.body.returnmsg=='Successful'){
            this.isDownloadBtn = true;
             this.codData = result.body.returnvalue;
                console.log(this.codData )
             this.noofpages = result.body.total_records / 10
            }
            else{
                this.isDownloadBtn = false;
                this.codData  =[]
            }
           
          })
          .catch(ex => {
            console.log('error', ex)
          });
    },

     getCodCollectionClosureCSV(){
        document.getElementById("overlay").style.display = "block";
        // alert(this.codCollectionDate)
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;

        var hubobj={
          hub_id:currenthub.toString(),
          fromdate: this.fromDate ? this.formatDate(this.fromDate) : this.codCollectionDate,
          todate: this.toDate ? this.formatDate(this.toDate) : this.codCollectionDate,
          page_no: this.pageNo ? this.pageNo : 1,
          limit: 10
        }
          this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/getCodCollectionClosureCSV`,hubobj)
         .then(Response => {

            document.getElementById("overlay").style.display = "none";
             if(Response.body){
                console.log(Response)
                this.downloadCSV(Response.body)
            } else {
               console.log("in else")
                this.downloadcsv='';
            }
            })

     },

     editCollectionClosure(row,showhide){
      
      var showhides=showhide;

      if(showhides)
      {

      }
      else{
        this.isEditOn=true;
        this.totalcodinhubwithdeficientamt();
        this.editReceiptno = row.item.receipt_no;
        this.editCodSubmiited = row.item.cod_submitted;
        this.editFile = [...row.item.uploaded_doc];
        this.editUploadedImages = [...row.item.uploaded_doc];
        this.editRemark = row.item.remark;
        //this.calculateEditDeficientAmt();
        //this.editDeficientamount = row.item.deficient_amount;
        console.log("Edit row-->",row.item);
      }
      
     },

     updateCodCollection(row){
      //alert("in update");
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var currentUser=userInfo.sysemailid;

      if(this.editCodSubmiited <= 0){
        this.$fire({
          text:"COD Deposit should be greater than 0",
          type: "warning",
          timer: 30000
        }); 
      }

      else if(this.editUploadedImages.length == 0){
        this.$fire({
          text:"Please Upload Document",
          type: "warning",
          timer: 30000
        }); 
      }

      else if(this.editDeficientamount < 0 ){
        this.$fire({
          text:"Deficit Amount cannot be less than 0",
          type: "warning",
          timer: 30000
        }); 
      }

      else{
        const Obj={
          req_id:row.item.id,
          hub_id:row.item.hub_id,
          total_cod_amount_in_hub: this.editTotalCodAmountInHub,
          cod_submitted: this.editCodSubmiited ? this.editCodSubmiited : this.codSubmiited,
          deficient_amount: this.editDeficientamount ? this.editDeficientamount : this.deficientamount,
          receipt_no: this.editReceiptno ? this.editReceiptno.toString(): this.receiptno.toString(),
          uploaded_doc: JSON.stringify(this.editUploadedImages),
          remark:this.editRemark,
          updated_by: currentUser
        }

        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/editCODReqByHubAdmin`, Obj)
        .then(result => {
          if(result.body.returnmsg==='Successful'){
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000
            }); 
            this.isEditOn = false;
            this.totalcodinhubwithdeficientamt();
            
          } 
          else{
            this.$fire({
              text:result.body.returnvalue,
              type: "error",
              timer: 30000
            }); 
            this.isEditOn = false;
          }
        })
      }
     },

    downloadCSV(data) {    
        const csvData = data
        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + csvData;
        anchor.download = 'COD_collection_data.csv';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    },
    

    calculateDeficientAmt(){
       if(this.codSubmiited == ''){
          this.deficientamount = 0;
       }
       else{
          let tempdeficientamt = (parseFloat(this.totalCodAmountInHub) - parseFloat(this.codSubmiited))
          
          if(tempdeficientamt < 0) {
                  this.$fire({
                  text: "Deficient Amount can not be negative",
                  type: "error",
                  timer: 30000
              });
              // this.deficientamount = tempdeficientamt; 
          }
        
           this.deficientamount = parseFloat(tempdeficientamt).toFixed(2);
        }
    },

    calculateEditDeficientAmt(){
      if(this.editCodSubmiited == ''){
        this.editDeficientamount = 0;
      }
      
      else{
        let tempdeficientamt = (parseFloat(this.editTotalCodAmountInHub) - parseFloat(this.editCodSubmiited))

        if(tempdeficientamt < 0) {
          this.$fire({
            text: "Deficient Amount can not be negative",
            type: "error",
            timer: 30000
          }); 
          
        } 
        this.editDeficientamount = parseFloat(tempdeficientamt).toFixed(2);
      }
     
    },

    refresh(){
        this.fromDate = new Date();
        this.toDate = new Date();
        this.pageNo = 1;
        this.getCodCollectionClosureList(this.pageNo);
    },

    formatDate: function(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("-");
    },

    searchClosureList(){
        // alert(this.codCollectionDate)
        document.getElementById("overlay").style.display = "block";
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        console.log("userInfo",userInfo)
        var currenthub=userInfo.pickuplocationmasterid;

        if(this.fromDate > this.toDate)
        {
             this.$fire({
                  text: "From date must be greater than To date",
                  type: "warning",
                  timer: 30000
                }); 
        }
        else{

        var hubobj={
          hub_id:currenthub.toString(),
          fromdate: this.fromDate ? this.formatDate(this.fromDate) : this.codCollectionDate,
          todate: this.toDate ? this.formatDate(this.toDate) : this.codCollectionDate,
          page_no: this.pageNo ? this.pageNo : 1,
          limit: 10
        }
         this.$http
          .post(`${CONSTANTS.MIGRATION_API_URL}/getCodCollectionClosureList`,hubobj)
          .then(result => {
            document.getElementById("overlay").style.display = "none";
            if(result.body.returnmsg=='Successful'){
            this.isDownloadBtn = true;
             this.codData = result.body.returnvalue;
                console.log(this.codData )
             this.noofpages = result.body.total_records / 10
            }
            else{
                this.isDownloadBtn = false;
                this.codData  =[]
            }
           
          })
          .catch(ex => {
            console.log('error', ex)
          });
        }

       
    },


  }


}

</script>


<style type="text/css">
.totalback {
  background: #c8ced3 !important;
  border-right: 1px solid grey !important;
}

.Collected {
  text-align: center !important;
}
#overlayloder {
  position: fixed; /* Sit on top of the page content */
  /*display: none;  Hidden by default */
  width: 100%; /* Full width (cover the whole page) */
  height: 100%; /* Full height (cover the whole page) */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* Black background with opacity */
  z-index: 2; /* Specify a stack order in case you're using a different order for other elements */
  cursor: pointer; /* Add a pointer on hover */
}
.loader_loder  {
  position: relative;
  border: 5px solid #f3f3f3;
  border-radius: 50%;
  border-top: 5px solid #3498db;
  width: 30px;
  height: 30px;
  left: 50%;
  top: 50%;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.bordered-value{

  padding:15px;
  border-bottom:1px solid #C8CED3;
  margin:-9px;
}

.hidden_header {
  display: none;
}

th{
  text-align:center;
}





</style>
